import {StyleSheet} from 'react-native';
import SkillzStyle from 'SkillzStyle';
import ClientPropertyConstants from 'ClientPropertyConstants';

// Legacy UI styles that are not theme-dependent
export const legacyStyles = StyleSheet.create({
  dataFeeStyleBold: {
    fontWeight: '600',
    textAlign: 'center',
  },
  dataFeeStyleLight: {
    fontWeight: '100',
    textAlign: 'center',
  },
});

export const createNewUIStyles = (gameTheme: any, isDarkTheme: boolean) => {
  const {
    textColorPrimary,
    textColorSecondary,
    textColorTertiary,
    fontBold,
    fontRegular,
    fontSizeH1,
    fontSizeH5,
    fontSizeH3,
    textColorError,
    cashIconGradient,
    btnTextColorOne,
    viewSecondaryColor,
    playButtonGradient,
  } = SkillzStyle.getOverriddenFallbackTheme() ?? {};

  return StyleSheet.create({
    container: {
      flex: 1,
    },
    phoneInputContainer: {
      marginTop: 12,
    },
    unifiedPhoneInput: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: isDarkTheme ? 'rgba(0, 0, 0, 0.25)' : viewSecondaryColor?.backgroundColor,
      opacity: 0.86,
      borderRadius: 16,
      borderWidth: 1,
      borderColor: playButtonGradient[0],
      paddingHorizontal: 4,
      paddingVertical: 4,
      height: 56,
    },
    countrySection: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 12,
      paddingVertical: 8,
    },
    flagContainer: {
      marginRight: 8,
    },
    flagImage: {
      width: 20,
      height: 15,
    },
    countryCodeText: {
      ...fontRegular,
      fontSize: 16,
      color: isDarkTheme ? textColorPrimary.color : textColorSecondary.color,
      marginRight: 8,
    },
    dropdownIcon: {
      width: 10,
      height: 8,
    },
    separator: {
      width: 1,
      height: '40%',
      backgroundColor: textColorTertiary.color,
    },
    phoneInputSection: {
      flex: 1,
      paddingHorizontal: 12,
      paddingVertical: 8,
      justifyContent: 'center',
    },
    phoneNumberInput: {
      ...fontRegular,
      fontSize: 16,
      color: isDarkTheme ? textColorPrimary.color : textColorSecondary.color,
      flex: 1,
      padding: 0,
      margin: 0,
    },
    nextButton: {
      borderRadius: 12,
      paddingVertical: 16,
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 32,
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.25,
      shadowRadius: 4,
      elevation: 3,
    },
    nextButtonText: {
      ...fontBold,
      ...fontSizeH3,
    },
    errorInput: {
      borderColor: textColorError.color,
    },
    errorSeparator: {
      backgroundColor: textColorError.color,
    },
    headerTitle: {
      ...fontRegular,
      ...fontBold,
      ...fontSizeH1,
      ...textColorPrimary,
      textAlign: 'center',
    },
    headerDescription: {
      ...fontRegular,
      ...fontSizeH5,
      ...textColorTertiary,
      textAlign: 'center',
      marginTop: 8,
    },
    resendBtn: {
      fontSize: 16,
      ...SkillzStyle.fullStyles.fontExtraBold,
      fontStyle: 'normal',
      color: cashIconGradient[0],
      textDecorationLine: 'underline',
      textAlign: 'center',
    },
    btnText: {
      ...btnTextColorOne,
      fontSize: 18,
      ...SkillzStyle.fullStyles.fontBold,
    },
    errorMessageNewUI: {
      top: 10,
    },
    nextButtonContainer: {
      marginTop: 16,
    },
    tosLinkNewUI: {
      textDecorationLine: 'underline',
      color: textColorPrimary?.color,
    },
    tosMessageNewUI: {
      color: textColorPrimary?.color,
      marginBottom: 0,
    },
    verificationCodeButtonContainer: {
      // 🔥 FIX: RP-6915 - Prevent button overlap on Login screen
      position: ClientPropertyConstants.getFTUEV2FeatureEnabled() ? 'relative' : 'absolute',
      bottom: ClientPropertyConstants.getFTUEV2FeatureEnabled() ? undefined : 0,
      right: ClientPropertyConstants.getFTUEV2FeatureEnabled() ? undefined : 0,
      left: ClientPropertyConstants.getFTUEV2FeatureEnabled() ? undefined : 0,
      marginTop: ClientPropertyConstants.getFTUEV2FeatureEnabled() ? 20 : undefined,
    },
  });
};
